























// @ is an alias to /src
import { Component, Vue, Watch } from 'vue-property-decorator'
import { AloMedia } from '@/models/alo/AloMedia'
import {getImageUrl} from '@/utils/images'

@Component({
  name: 'ImageDetail',
  props:{
    img:{
      type:Object,
      required:true

    },
    allowOrder:{
      type:Boolean,
      default:true
    }
  }    
})
export default class ImageDetail extends Vue {
  
  private img!:AloMedia  
  private zoom = false
  private allowOrder!:boolean
  
  get imageSmallUrl() {
     return getImageUrl(this.img,130,102)
  }

  get imageLargeUrl() {
     return getImageUrl(this.img,1200)
  }

  deleteImage() {
    this.$emit("delete",this.img)
  }

  editImage() {
    this.$emit("edit",this.img)
  }
}
